<template>
  <div class="wrap">
    <p class="title van-hairline--bottom">{{ $t("fail_reason.page_title") }}</p>
<!--    <p class="sub-title">可能不通过的原因:</p>-->
    <div class="content" v-if="currentData.pass_reason">
      {{ currentData.pass_reason }}
    </div>
    <div class="btn-submit" @click="submit">
      {{ currentData.status == 5 ? $t("deTopic.derivative.t49") : $t("deTopic.derivative.t50")}}
    </div>
  </div>
</template>

<script>
import { closeWebView } from "@/utils/hybirdMethods";
import { getBrowser } from "@/utils/browser";
export default {
  data() {
    return {
      currentData: {}
    };
  },
  created() {
    this.getAccountSituationApi();
  },
  methods: {
    //   获取开户状态
    getAccountSituationApi() {
      this.$apis.getAccountSituation().then(res => {
        const {
          extra_open_info_hk,
          extra_open_info_hb,
          is_verify_hk,
          is_verify_hb
        } = res;
        let currentData;
        let openType;
        // 证券
          // 开了
            // 只能加开期货
              // 加开期货  3
          // 没开
            // 期货
              // is_verify_hk == 1 2
            // 证券
              // is_verify_hb == 1  1

        // 开了期货 没开证券
        if(is_verify_hk == 2 && is_verify_hb != 2){
          if(extra_open_info_hk.status != 1){
             // 期货
            openType = 3;
            currentData = extra_open_info_hk;
          }
          if(extra_open_info_hb.status != 1){
            // 证券
            openType = 1;
            currentData = extra_open_info_hb;
          }
        }
        // 没开期货 开了证券
        else if(is_verify_hk != 2 && is_verify_hb == 2){
          openType = 2;
          currentData = extra_open_info_hk;
        }
        // 都开了
        else if(is_verify_hk == 2 && is_verify_hb == 2){
          openType = 3;
          currentData = extra_open_info_hk;
        }
        this.currentData = currentData;
        this.openType = openType;
      });
    },
    submit() {
      const { currentData, openType } = this;
      if (currentData) {
        if(currentData.status == 5){
          // 我知道了
          this.$apis.accountKnowSet({
            open_info_record_id: this.currentData.id
            })
            .then(res => {
              //   关闭webview
              const browser = getBrowser();
              if (browser.isApp) {
                closeWebView();
              }
          });
        } else {
          // 去修改
          this.$router.push({
            path: "/open-account/investmentExperience",
            query: {
              ...this.$route.query,
              openType,
              fromChangInfoPage: 1,
              open_info_record_id: this.currentData.id
            }
          });
        }
      }
    }
  }
};
</script>

<style lang="less" scoped>
.wrap{
  padding: 0 20px;
  .title{
    line-height: 48px;
    font-size: 40px;
    font-weight: 600;
    padding: 20px 0;
  }
  .sub-title{
    color: rgb(204, 0, 0);
    margin: 20px 0;
  }
  .content{
    margin-top: 20px;
  }
  .btn-submit{
    margin: 40px 50px;
    height: 100px;
    text-align: center;
    line-height: 100px;
    background-color: #17161C;
    color: #fff;
    font-size: 32px;
    border-radius: 100px;
  }
}
.black-theme{
  .wrap{
    .title,.content{
      color: #fff;
    }
    .van-hairline--bottom:after{
      border-color: rgba(255,255,255,.25);
    }
    .btn-submit{
      background: #377CFB;
    }
  }
}
</style>
